import './Popup.less'
import Popup from './Popup'

export type { PopupProps } from './iPopup'

export default Popup
